import React from 'react';
import intl from 'react-intl-universal';
import Dropdown from 'src/ui/library/Dropdown';
import DateInput from 'src/ui/library/DateInput';
import MenuItem from '@material-ui/core/MenuItem';
import TextInput from 'src/ui/library/TextInput';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

const FiltersPres = props => {
  const {
    filters: { documentType, entity, engagements, countryList, employee, tags, yearList },
    filterIndexes: {
      dateFrom_input,
      dateTo_input,
      dateFrom,
      dateTo,
      documentTypeIndex,
      countryIndex,
      yearIndex,
      entityIndex,
      tagIndex,
      employeeIndex,
      clientIndex,
      CasePhaseIndex,
      caseContactEmailId,
      addedDocsAfterAllDocsSubmitted,
      acknowledgedIndex,
    },
    onChange,
    onChangeDate,
    onTextChange,
    handlingDocssubmitted,
    applyFilters,
    clearFilters,
    isApplicant,
    isCase,
    casePhaseList,
    isLoading,
    isLoadingfornonClick,
    setFiltersDivVisibilityState,
  } = props;

  if (!documentType) return null;

  const acknowledge = [
    {
      id: true,
      value: 'Yes',
    },
    {
      id: false,
      value: 'No',
    },
  ];

  return (
    <div>
      {isLoadingfornonClick && <ServiceSpinner classname="ssi-spinner-mini" />}
      {isLoading && <ServiceSpinner open={isLoading} />}
      <div className="filter-box-container documents">
        <div>
          <Dropdown
            id="documentType"
            name="documentType"
            label={intl.get('documents.filters.labels.documentType')}
            className="filterlongtxt"
            onChange={onChange}
            value={documentTypeIndex === undefined ? [] : documentTypeIndex}
            InputLabelProps={{
              shrink: true,
            }}
            disableUnderline={true}
            styleType={'cases'}>
            {documentType
              ? documentType.map((item, i) => (
                  <MenuItem value={i} id={item.id} key={`${item.name + '-' + i}`}>
                    {item.name}
                  </MenuItem>
                ))
              : null}
          </Dropdown>
        </div>
        {isApplicant ? null : (
          <div>
            <Dropdown
              id="entity"
              name="entity"
              label={intl.get('documents.filters.labels.entity')}
              className="filterlongtxt"
              onChange={onChange}
              value={entityIndex === undefined ? [] : entityIndex}
              InputLabelProps={{
                shrink: true,
              }}
              disableUnderline={true}
              styleType={'cases'}>
              {entity
                ? entity.map((item, i) => (
                    <MenuItem value={i} id={item.id} key={`${item.name + '-' + i}`}>
                      {item.name}
                    </MenuItem>
                  ))
                : null}
            </Dropdown>
          </div>
        )}
        {isApplicant ? null : (
          <div>
            <Dropdown
              id="employee"
              name="employee"
              label={intl.get('documents.filters.labels.employee')}
              className="filterlongtxt"
              onChange={onChange}
              value={employeeIndex === undefined ? [] : employeeIndex}
              InputLabelProps={{
                shrink: true,
              }}
              disableUnderline={true}
              styleType={'cases'}>
              {employee
                ? employee.map((item, i) => (
                    <MenuItem value={i} id={item.id} key={`${item.name + '-' + i}`}>
                      {item.name}
                    </MenuItem>
                  ))
                : null}
            </Dropdown>
          </div>
        )}
        {isApplicant ? null : (
          <div>
            <Dropdown
              id="tag"
              name="tag"
              label={intl.get('documents.filters.labels.tags')}
              className="filterlongtxt"
              onChange={onChange}
              value={tagIndex === undefined ? [] : tagIndex}
              InputLabelProps={{
                shrink: true,
              }}
              disableUnderline={true}
              styleType={'cases'}>
              {tags
                ? tags.map((item, i) => (
                    <MenuItem value={i} id={item.id} key={`${item.name + '-' + i}`}>
                      {item.name}
                    </MenuItem>
                  ))
                : null}
            </Dropdown>
          </div>
        )}
        <div />
        <div>
          <DateInput
            value={dateFrom_input}
            id={`dateFrom`}
            name="dateFrom"
            label={intl.get('documents.filters.labels.dateFrom')}
            format="YYYY-MM-DD"
            onChange={date => onChangeDate(date, 'dateFrom')}
            maxDate={dateTo}
            styleType={'landing'}
            className="date-hover"
          />
        </div>

        <div>
          <DateInput
            value={dateTo_input}
            id={`dateTo`}
            name="dateTo"
            label={intl.get('documents.filters.labels.dateTo')}
            format="YYYY-MM-DD"
            onChange={date => onChangeDate(date, 'dateTo')}
            minDate={dateFrom}
            styleType={'landing'}
            className="date-hover"
          />
        </div>
        <div>
          <Dropdown
            id="acknowledged"
            name="acknowledged"
            label={intl.get('documents.filters.labels.acknowldeged')}
            className="filterlongtxt"
            onChange={onChange}
            value={acknowledgedIndex === undefined ? [] : acknowledgedIndex}
            InputLabelProps={{
              shrink: true,
            }}
            disableUnderline={true}
            styleType={'cases'}>
            {acknowledge
              ? acknowledge.map((item, i) => (
                  <MenuItem value={i} id={item.id} key={`${item.value + '-' + i}`}>
                    {item.value}
                  </MenuItem>
                ))
              : null}
          </Dropdown>
        </div>
        {isCase ? null : (
          <div>
            <Dropdown
              id="client"
              name="client"
              label={intl.get('documents.filters.labels.engagementName')}
              className="filterlongtxt"
              onChange={onChange}
              value={clientIndex === undefined ? [] : clientIndex}
              InputLabelProps={{
                shrink: true,
              }}
              disableUnderline={true}
              styleType={'cases'}>
              {engagements
                ? engagements.map((item, i) => (
                    <MenuItem value={i} id={item.id} key={`${item.name + '-' + i}`}>
                      {item.name}
                    </MenuItem>
                  ))
                : null}
            </Dropdown>
          </div>
        )}
        {isCase ? null : (
          <div>
            <Dropdown
              id="country"
              name="country"
              className="filterlongtxt"
              label={intl.get('cases.filters.labels.country')}
              onChange={onChange}
              value={countryIndex === undefined ? [] : countryIndex}
              InputLabelProps={{
                shrink: true,
              }}
              disableUnderline={true}
              styleType={'cases'}>
              {countryList
                ? countryList.map((item, i) => (
                    <MenuItem value={i} id={item.countryId} key={`${item.country + '-' + i}`}>
                      {item.country}
                    </MenuItem>
                  ))
                : null}
            </Dropdown>
          </div>
        )}
        {isCase ? null : (
          <div>
            <Dropdown
              id="year"
              name="year"
              label={intl.get('cases.filters.labels.caseYear')}
              className="filterlongtxt"
              onChange={onChange}
              value={yearIndex === undefined ? [] : yearIndex}
              InputLabelProps={{
                shrink: true,
              }}
              disableUnderline={true}
              styleType={'cases'}>
              {yearList
                ? yearList.map((item, i) => (
                    <MenuItem value={i} id={item.year} key={`${item.year + '-' + i}`}>
                      {item.year}
                    </MenuItem>
                  ))
                : null}
            </Dropdown>
          </div>
        )}
        {isCase ? null : (
          <div>
            <Dropdown
              id="CasePhase"
              name="CasePhase"
              className="filterlongtxt"
              label={intl.get('cases.filters.labels.casePhase')}
              onChange={onChange}
              value={CasePhaseIndex === undefined ? [] : CasePhaseIndex}
              InputLabelProps={{
                shrink: true,
              }}
              disableUnderline={true}
              styleType={'cases'}>
              {casePhaseList &&
                  casePhaseList.map(
                    (item, i) =>
                      item.phase && (
                        <MenuItem value={i} id={item.phaseId} key={`${item.phase + '-' + i}`}>
                          {item.phase}
                        </MenuItem>
                      ),
                  )}
            </Dropdown>
          </div>
        )}
        {isCase ? null : (
          <div className="caseContactEmail">
            <TextInput
              id="caseContactEmail"
              name="caseContactEmail"
              label={intl.get('cases.filters.labels.caseContactEmailAddress')}
              onChange={evt => onTextChange(evt)}
              value={caseContactEmailId}
              InputLabelProps={{
                shrink: true,
              }}
              disableUnderline={true}
              styleType={'cases'}
            />
          </div>
        )}
        {isCase ? null : (
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={addedDocsAfterAllDocsSubmitted}
                  onChange={event => handlingDocssubmitted(event)}
                  style={{
                    color: '#4d4848',
                  }}
                />
              }
              label={intl.get('cases.filters.labels.AddedDocs')}
            />
          </div>
        )}
      </div>
      <div className="documents-filter-buttons">
        <a
          className="documents-filterBox-button-link"
          onClick={e => {
            applyFilters(e);
            setFiltersDivVisibilityState(true);
          }}>
          {intl.get('cases.filters.apply')}
        </a>
        <a
          className="filterBox-button-link"
          onClick={() => {
            clearFilters('click');
            setFiltersDivVisibilityState(true);
          }}>
          {intl.get('cases.filters.clear')}
        </a>
      </div>
    </div>
  );
};

export default FiltersPres;



// WEBPACK FOOTER //
// ./src/ui/features/Documents/presentational/FilterBox/FiltersPres.js